import {
  ContextMenu as RadixContextMenu,
  ContextMenuPortal,
  ContextMenuTrigger,
} from '@radix-ui/react-context-menu';

import { ContextMenuContent } from './ContextMenuContent';
import { ContextMenuItem } from './ContextMenuItem';

export const ContextMenu = {
  Root: RadixContextMenu,
  Content: ContextMenuContent,
  Trigger: ContextMenuTrigger,
  Portal: ContextMenuPortal,
  Item: ContextMenuItem,
};
